<template>
    <div class="v-input theme--light v-text-field v-text-field--is-booted" :class="vClass">
        <div class="v-input__control">
            <div class="v-input__slot">
                <div class="v-text-field__slot">
                    <input
                        v-model.lazy="internalValue"
                        :type="type"
                        :placeholder="dataVvAs"
                        :name="fieldId"
                        :id="fieldId"
                        :v-validate="vValidate"
                        :data-vv-as="dataVvAs"
                        :data-vv-name="dataVvName"
                        autocomplete="off"
                    >
                </div>
            </div>
            <div :class="{'v-text-field__details': true, 'show': errorMessages.length > 0}">
                <div class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                        <div class="v-messages__message" v-for="errorMessage in errorMessages">{{ errorMessage }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VOfferRowField',
    props: {
        value: {
            type: [String, Number],
            default() {
                return null
            }
        },
        vValidate: {
            type: String,
            default() {
                return ''
            }
        },
        errorMessages: {
            type: Array,
            default() {
                return []
            }
        },
        vClass: {
            type: [Object, Array, String],
            default() {
                return []
            }
        },
        dataVvAs: {
            type: String,
            default() {
                return ''
            }
        },
        dataVvName: {
            type: String,
            default() {
                return ''
            }
        },
        type: {
            type: String,
            default() {
                return 'text'
            }
        }
    },
    data () {
        return {
            internalValue: this.value,
            fieldId: undefined
        }
    },
    created() {
        this.fieldId = this.generateId()
    },
    watch: {
        value: {
            handler (val) {
                this.internalValue = val
            }
        },
        internalValue: {
            handler (val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        generateId(length = 10) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }
    }
}
</script>
